/* eslint-disable no-console */
import React, { useState } from "react";
import { Button, Icon, Confirm, Popup, Label } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { ClassSchedule } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { ClassScheduleForm } from "../ClassScheduleForm";
import "./ClassScheduleItem.scss";

const classScheduleController = new ClassSchedule();

export function ClassScheduleItem(props) {
  const { classSchedule, onReload, gradeId, academicCycleId } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateClassSchedule = () => {
    setTitleModal(`Actualizar horario: ${classSchedule.CourseTeacher?.Subject?.name || 'Sin asignatura'}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar el horario de ${classSchedule.CourseTeacher?.Subject?.name || 'Sin asignatura'}?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await classScheduleController.deleteClassSchedule(accessToken, classSchedule.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const getDayName = (dayOfWeek) => {
    const days = {
      1: "Lunes",
      2: "Martes", 
      3: "Miércoles",
      4: "Jueves",
      5: "Viernes",
      6: "Sábado",
      7: "Domingo"
    };
    return days[dayOfWeek] || "Sin definir";
  };

  const formatTime = (time) => {
    if (!time) return "Sin definir";
    return time.substring(0, 5); // Extract HH:MM from HH:MM:SS format
  };

  return (
    <>
      <div className="class-schedule-item">
        <div className="class-schedule-item__info">
          <span className="class-schedule-item__info-subject">
            {classSchedule.CourseTeacher?.Subject?.name || "Sin asignatura"}
          </span>
          <span className="class-schedule-item__info-teacher">
            {classSchedule.CourseTeacher?.User ? 
              `${classSchedule.CourseTeacher.User.firstname} ${classSchedule.CourseTeacher.User.lastname} ${classSchedule.CourseTeacher.User.secondLastname || ""}`.trim() 
              : "Sin profesor"
            }
          </span>
        </div>
        <div className="class-schedule-item__info">
          <span className="class-schedule-item__info-room">
            Aula: {classSchedule.roomId || "Sin aula"}
          </span>
          <Label color="blue">
            {getDayName(classSchedule.dayOfWeek)}
          </Label>
        </div>
        <div className="class-schedule-item__info">
          <span className="class-schedule-item__info-time">
            {formatTime(classSchedule.startTime)} - {formatTime(classSchedule.endTime)}
          </span>
          {classSchedule.notes && (
            <span className="class-schedule-item__info-notes">
              {classSchedule.notes}
            </span>
          )}
        </div>
        <div>
          <Popup
            content="Actualizar horario"
            trigger={
              <Button icon primary onClick={openUpdateClassSchedule}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content="Eliminar horario"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <ClassScheduleForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          classSchedule={classSchedule}
          gradeId={gradeId}
          academicCycleId={academicCycleId}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}